import React, { Suspense } from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import reportWebVitals from './reportWebVitals';
import { Route, HashRouter as Router, Routes, Link, useParams  } from 'react-router-dom'
import Container from 'react-bootstrap/Container'
import Spinner from 'react-bootstrap/Spinner'
import 'bootstrap/dist/css/bootstrap.min.css';
import { InteractiveRenderer, Interactive, deepMap, hydrate } from "@bittnerdevelopmentgroup/interactive-builder"

const AdminPage = React.lazy(() => import('./AdminPage'));

const context = require.context('../public/interactives', true, /\.yml$/)
const context_paths = {}
const context_interactives = []
context.keys().forEach(k=>{
  const name = k.substr(2, k.length - 6)
  if (!name.endsWith(".manifest")) {
    context_interactives.push(name)
    context_paths[name] = k.substr(2)
  }
})
const context2 = require.context('../public/interactives', true, /\.json$/)
context2.keys().forEach(k=>{
  const name = k.substr(2, k.length - 7)
  if (!name.endsWith(".manifest")) {
    context_interactives.push(name)
    context_paths[name] = k.substr(2)
  }
})

function loadFetchedInteractive(r) {
  let i = new Interactive({
    ...r,
    panels: deepMap(r.panels, hydrate),
  })
  return i
}

function Path() {
  let { name } = useParams()
  let path = context_paths[name]
  console.log("Path", path)
  const [data, setData] = React.useState()
  const [error, setError] = React.useState()
  React.useEffect(()=>{
    if (data === undefined) {
      console.log("Path loading", `../public/interactives/${path}`)
      import(`../public/interactives/${path}`).then(data => {
        console.log("data", data)
        if (path.endsWith(".json")) {
          data.default.panels = data.default.panels.map(JSON.parse)
          setData(loadFetchedInteractive(data?.default))
        } else {
          setData(loadFetchedInteractive(data?.default?.interactive))
          document.title = data?.default?.title
        }
      }).catch(e=>{
        console.log("Error", e)
        setError(e.message)
      })
    }
    return ()=>{
      console.log("Path unload")
    }
  }, [data, name, path])
  if (data) {
    console.log("staging data")
    return <InteractiveRenderer fullWidth data={data} attributes={{interactiveId: `TRW-${name}`, interactiveIds: data.interactiveIds}}/>
  }
  if (error) {
    return <code style={{whiteSpace: 'pre', color: 'red'}}>{error}</code>
  }
  return <Spinner animation="border"/>
}

function LandingPage() {
  return <div>
    <ul>
      {context_interactives.map(name=>{
        return <li key={name}>
          <Link to={`/${name}`}>{name}</Link>
        </li>
      })}
    </ul>
    <span className="bdg-link">
      <Link to={`/collections/interactives`}>BDG</Link>
    </span>
  </div>
}

function RoutePath(props) {
  const params = useParams()
  const name = params?.name
  return <Path key={name} name={name}/>
}

ReactDOM.render(
  <React.StrictMode>
    <Container>
      <Router>
        <Suspense fallback={<Spinner animation="border"/>}>
          <Routes>
            <Route exact path="/" element={<LandingPage />}/>
            <Route exact path="/collections/interactives" element={<AdminPage/>}/>
            <Route path={`/:name`} element={<RoutePath />}/>
          </Routes>
        </Suspense>
      </Router>
    </Container>
  </React.StrictMode>,
  document.getElementById('root')
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();